import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isLoading: false,
  submitLoading: false,
};

export const stateSlice = createSlice({
  name: "navigationState",
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    startSubmitLoading: (state) => {
      state.submitLoading = true;
    },
    stopSubmitLoading: (state) => {
      state.submitLoading = false;
    },
  },
});

export const {
  startLoading,
  stopLoading,
  startSubmitLoading,
  stopSubmitLoading,
} = stateSlice.actions;

export default stateSlice.reducer;
